import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";

export interface CustomerItem {
    label: string
    customerNumber: string
    id: string
}

class ScanCustomerStore {
    get items(): CustomerItem[] {
        return this._items;
    }

    set items(value: CustomerItem[]) {
        this._items = value;
    }

    private _items: CustomerItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async search(query: string): Promise<CustomerItem[]> {
        const response = await catchApi(async () => api.sea.api.findCustomers({query: query}))
        return (response?.data || []).map(item => ({
            label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
            customerNumber: `${item.customerNumber}`,
            id: `${item.customerId}`
        }))
    }

    async init() {
        if (!this.items.length) {
            await this.load()
        }
    }

    async load() {
        const response = await catchApi(async () => await api.sea.api.findCustomers())
        if (response && response.data) {
            this.items = (response.data || []).map(item => ({
                label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
                customerNumber: `${item.customerNumber}`,
                id: `${item.customerId}`
            }))
        }
    }

    getCustomerById(customerId: string | undefined): CustomerItem | undefined {

        if (customerId) {
            return this.items.find(e => e.id === customerId)
        }
    }
}

const scanCustomerStore = new ScanCustomerStore()

export {
    scanCustomerStore
}
